"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePlacementSlipDto = void 0;
const mapped_types_1 = require("@nestjs/mapped-types");
const create_placement_slip_dto_1 = require("./create-placement-slip.dto");
class UpdatePlacementSlipDto extends (0, mapped_types_1.PartialType)(create_placement_slip_dto_1.CreatePlacementSlipDto) {
}
exports.UpdatePlacementSlipDto = UpdatePlacementSlipDto;
